export default (idx) => ({
    idx,
    currentHeight: 0,

    init(){
        const observer = new MutationObserver(() => {
            this.$refs.accordion.style.maxHeight = this.$refs.accordion.scrollHeight + 'px';
        });
        observer.observe(this.$refs.accordion, { childList: true, subtree: true });
    },

    get isOpen() {
        return this.currentAccordion === this.idx;
    },

    handleClick() {
        this.currentAccordion = this.isOpen
            ? 0
            : this.idx;
    },
});
